// data: {token: string, expiresAt: string}
export const setAuthToken = ({ token, expiresAt }) => {
  try {
    // Store the credentials
    return localStorage.setItem("token", JSON.stringify({ token, expiresAt }))
  } catch (error) {
    console.error("Failed to store authentication token:", error)
    return null
  }
}

export const getAuthToken = () => {
  const data = localStorage.getItem("token")
  if (!data) return undefined

  try {
    const { token, expiresAt } = JSON.parse(data)
    if (!token || new Date(expiresAt) <= new Date()) {
      return undefined
    }
    return token
  } catch {
    return undefined
  }
}

export const clearAuthToken = () => {
  try {
    // Remove credentials from the secure storage
    return localStorage.removeItem("token")
  } catch (error) {
    console.error("Failed to delete authentication token:", error)
    return null
  }
}
